<template>
  <div>
    <breadcrumb :items="breadcrumbs"></breadcrumb>
    <v-container fluid>
      <div class="page-title">
        <h2>Activity Log</h2>
        <v-spacer></v-spacer>

        <!-- <v-btn
          color="primary"
          @click="$router.push({ name: 'DrugRegister' })"
        >
          Register a Drug
        </v-btn> -->
      </div>
      <v-card elevation="10" class="px-5">
        <v-card-text>
          <v-data-table
            :headers="headers"
            :items="items"
            :items-per-page="10"
            v-model="selected"
            show-select
            item-key="drugNumber"
            :loading="loading"
            loading-text="Loading Drugs... Please wait"
            :hide-default-footer="true"
            :footer-props="{
              'items-per-page-options': [5, 10, 25],
              'show-first-last-page': true,
              'show-current-page': true,
              'items-per-page-text': 'Drugs per page',
            }"
            :options.sync="tableOptions"
            :server-items-length="totalLogs"
          >
            <template v-slot:top>
              <div class="d-flex mt-5">
                <v-text-field
                  prepend-inner-icon="mdi-magnify"
                  outlined
                  height="5px"
                  placeholder="Search"
                  dense
                  v-model="search"
                  @click:append="searchDrugs"
                  @input="resetSearchOnEmpty"
                  class="shrink"
                ></v-text-field>
                <v-spacer></v-spacer>
                <div class="py-1 title">
                  {{ from }} - {{ to }} of {{ totalLogs }}
                </div>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page <= 1"
                  @click="pageChange(false)"
                >
                  <v-icon dark> mdi-chevron-left </v-icon>
                </v-btn>
                <v-btn
                  class="mx-2"
                  fab
                  small
                  outlined
                  color="primary"
                  :disabled="tableOptions.page >= totalPages"
                  @click="pageChange(true)"
                >
                  <v-icon dark> mdi-chevron-right </v-icon>
                </v-btn>
                <v-btn
                                class="mx-2"
                                fab
                                small
                                outlined
                                color="primary"
                                disabled
                            >
                                <v-icon dark>
                                    mdi-cog-outline
                                </v-icon>
                            </v-btn>
              </div>
            </template>
            <template v-slot:progress>
              <v-progress-linear
                color="primary"
                :height="6"
                indeterminate
              ></v-progress-linear>
            </template>
            <template v-if="items.length > 0" v-slot:body="{ items }">
              <tbody>
                <tr
                  v-for="item in items"
                  :key="item.drugNumber"
                  @mouseover="selectItem(item)"
                  @mouseleave="unSelectItem()"
                  style="position: relative; width: 0; height: 0"
                  @click="setDialog(item)"
                >
                  <td>
                    <v-checkbox
                      multiple
                      v-model="selected"
                      :value="item"
                      style="margin: 0px; padding: 0px"
                      hide-details
                    />
                  </td>
                  <td>{{ item.createdAt }}</td>
                  <td>{{ item.userName }}</td>
                  <td>{{ item.role }}</td>
                  <td>{{ item.department }}</td>
                  <td>{{ item.module }}</td>
                  <td>{{ item.title }}</td>
                  <td>{{ item.accessType }}</td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-container>
    <single-page
      :newdialog="dialog"
      :unset="unsetDialog"
      :item="newItem"
    ></single-page>
  </div>
</template>

<script>
import loadingMixin from "@/mixins/LoadingMixin";
import Breadcrumb from "@/components/core/Breadcrumb";
import UserService from "@/_services/UserService";
import SinglePage from "./SinglePage.vue";
export default {
  components: {
    breadcrumb: Breadcrumb,
    SinglePage,
  },
  watch: {
    tableOptions: {
      handler() {
        this.getLogData();
      },
      deep: true,
    },
  },
  async mounted() {
    document.title = "ActivityLog";
  },
  methods: {
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem() {
      this.selectedItem = false;
    },
    searchDrugs() {
      console.log("ser", this.search);
      if (this.search == "") return;
      this.tableOptions.page = 1;
      this.getLog();
    },
    resetSearchOnEmpty() {
      if (this.search === "") return;
      this.tableOptions.page = 1;
      this.getLog();
    },
    async setDialog(item) {
      this.dialog = true;
      this.newItem = item;
      console.log("new", this.newItem);
    },
    unsetDialog(data) {
      console.log("hello");
      this.dialog = data;
    },
    getLogData() {
      this.getLog();
      // console.log(sortBy, sortDesc) // shortBy = email, sortDesc true/false
    },
    getLog() {
      this.loading = true;
      UserService.getLogs(this.tableOptions, this.search)
        .then((res) => {
          console.log(res);
          if (res.success) {
            this.items = res.data.activities.rows;
            this.currentrows = res.data.activities.num_rows;
            this.totalLogs = res.data.activities.total_rows;
            this.pageCount = Math.ceil(
              this.totalLogs / this.tableOptions.itemsPerPage
            );
            this.totalPages = Math.ceil(
              this.totalLogs / this.tableOptions.itemsPerPage
            );
            this.from =
              (this.tableOptions.page - 1) * this.tableOptions.itemsPerPage + 1;
            this.to =
              this.tableOptions.page * this.tableOptions.itemsPerPage -
              (this.tableOptions.itemsPerPage - res.data.activities.num_rows);
            this.loading = false;
          }
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    pageChange(t) {
      if (t) this.tableOptions.page = this.tableOptions.page + 1;
      else this.tableOptions.page = this.tableOptions.page - 1;

      this.getLog();
    },
  },
  data() {
    return {
      to: "",
      from: "",
      totalPages: "",
      transition: true,
      pageCount: 1,
      currentrows: 0,
      search: "",
      newItem: {},
      selected: [],
      items: [],
      totalLogs: 1,
      selectedItem: false,
      tableOptions: {},
      loading: false,
      dialog: false,
      // loadingText: "Loading... Please wait",
      breadcrumbs: [
        {
          text: "Dashboard",
          disabled: false,
          to: "/",
        },
        {
          text: "Activity Log",
          disabled: true,
        },
      ],
      headers: [
        {
          text: "Time",
          align: "start",
          class: "black--text",
          value: "createdAt",
        },
        { text: "User Name", value: "userName", class: "black--text" },
        {
          text: "Role",
          value: "role",
          class: "black--text",
        },
        {
          text: "Department",
          value: "department",
          class: "black--text",
        },
        {
          text: "Module Accessed",
          value: "module",
          class: "black--text",
        },
        {
          text: "Title",
          value: "title",
          class: "black--text",
        },
        {
          text: "Types of Access",
          value: "accessType",
          class: "black--text",
        },
      ],
    };
  },
  mixins: [loadingMixin],
};
</script>

<style lang="scss" scoped>
::v-deep .v-data-table-header {
  background: $secondary2-color;
}
::v-deep .v-data-table-header span {
  text-transform: uppercase !important;
  color: black;
}
.route {
  text-decoration: none !important;
}
</style>